import { TDataLanding } from "../../../../components/Lending/types";
import { config } from "../../../../config";
import useSWR from "swr";

const getLanding = async (landingSlug: string) => {
  const res = await fetch(`${config.serverURL}api/landings/${landingSlug}`);
  const data: TDataLanding = await res.json();
  return data;
};

export const useGetlanding = (landingSlug: string) => {
  const { data: landingData, mutate } = useSWR(
    ["getLanding", landingSlug],
    () => getLanding(landingSlug),
    {
      revalidateOnFocus: false,
    }
  );
  return { landingData, mutate };
};
